import { createHistoryRouter } from 'atomic-router';
import { createBrowserHistory } from 'history';
import {
  homeRoute, projectsRoute, enHomeRoute, enProjectsRoute, notFoundRoute,
} from './index';

export const routes = [
  { path: '/', route: homeRoute },
  { path: '/en', route: enHomeRoute },
  { path: '/projects', route: projectsRoute },
  { path: '/en/projects', route: enProjectsRoute },
];

export const router = createHistoryRouter({
  routes,
  notFoundRoute,
});

const history = createBrowserHistory();

router.setHistory(history);
